export const manualInvoiceModal = {
  modalTitle: {
    create: "Create invoice manually",
    correcting: "Correct invoice details",
  },
  confirm: {
    title: "Review before creating",
    subtitle:
      "A draft will be created. You can review it, add charges and issue it whenever you want.",
    rowDocument: "Document",
    documentValue: "Draft · number on issue",
    rowType: "Type",
    typeCompany: "Company / Legal entity",
    typeIndividual: "Individual",
    labelCompanyName: "Legal name",
    labelName: "Name",
    rowCountry: "Country",
    rowEmail: "Email",
    rowAddress: "Address",
    rowPayment: "Payment",
    rowNotes: "Notes",
  },
  info: {
    createTitle: "A DRAFT invoice will be created (no number until issued).",
    correctingTitle: "Correcting tax details",
    createBody:
      "It will be saved as a draft. You can add charges and, once it's ready, issue it — the sequential number is assigned by the tax authority on issue.",
    correctingBody:
      "Change only the details you need to correct. A <strong>corrective invoice</strong> will be generated with the correct details.",
  },
  prefillLoading: "Loading the guest's tax details…",
  // Facturar toda la reserva o una sola habitación (reservas de varias).
  scope: {
    lead: "This booking has several rooms. Which invoice do you want to create?",
    continue: "Continue",
    label: "How do you want to invoice?",
    whole: "The whole booking",
    wholeHint: "A single invoice with all {n} rooms.",
    perRoom: "One room",
    perRoomHint: "Each room, its own invoice: its nights and its charges.",
    pickRoom: "Pick the room",
    repeatHint: "Repeat for each room so every guest gets their own.",
  },

  recipientType: {
    label: "Recipient type",
    individual: "Individual",
    individualSub: "Natural person",
    company: "Company",
    companySub: "Legal entity",
    active: "Active",
  },
  // Buscador de clientes del fichero dentro del modal: evita teclear a mano
  // una empresa que ya está guardada.
  client: {
    label: "Saved client",
    help: "Search your client file and the tax details fill in on their own. If the client is not there, type the details by hand.",
    clear: "Remove",
    linkedHint: "Details taken from the client's file. You can correct any field without losing the link to the client.",
    noFiscalProfile: "That client has no saved billing profile: we brought their name and email, the rest has to be typed in (or complete their file in Clients).",
  },
  fields: {
    nameCompany: "Legal name *",
    nameIndividual: "Full name *",
    country: "Country",
    countryPlaceholder: "Select the guest's country",
    countryHint: "Enter the guest's tax country for the invoice.",
    optional: "(optional)",
    emailLabel: "Billing email",
    phoneLabel: "Phone",
    addressLabel: "Tax address",
    sectionInvoiceData: "Invoice details",
    paymentSourceLabel: "Payment source",
    paymentHintPrefilled:
      "Marked from the payments you recorded. Change it if it's not correct.",
    paymentHintMulti:
      "You can mark several if the stay was paid in more than one way.",
    paymentHintNone: "If nothing is marked, the invoice won't state how it was paid.",
    seriesLabel: "Series",
    seriesHint: "This series comes from your billing settings.",
    notesLabel: "Additional invoice details",
    notesHint:
      "Use it to add a free-text concept, clarifications or extra issuance details.",
  },
  preview: {
    label: "Next sequential number",
    estHint: "for reference · assigned on issue (the first to issue takes it)",
    noNumber: "Assigned on issue · the draft has no number",
  },
  footer: {
    cancel: "Cancel",
    create: "Create invoice",
    editData: "Edit details",
    creating: "Creating...",
    createDraft: "Create draft",
  },
  success: {
    title: "Invoice issued!",
    badge: "Issued",
    pdfGenerating: "The PDF is being generated. It may take a few seconds.",
    downloadPdf: "Download PDF invoice",
    generatingPdf: "Generating PDF…",
    sendWhatsapp: "Send via WhatsApp",
    closeWindow: "Close window",
  },
  paymentSource: {
    cash: "Cash",
    card: "Credit card",
    transfer: "Bank transfer",
    otherOta: "Paid via another OTA",
  },
  prefill: {
    clientFile:
      "Details taken from the client's file. Review them before creating the draft.",
    invoiceRecipient: "Details preloaded from the guest's last invoice.",
    chat: "Tax details the guest provided when requesting their invoice. Review them and issue.",
    checkin:
      "We preloaded the guest's name and email from their check-in. Complete their tax details below.",
    reservation:
      "There were no complete tax details; the booking's basic details are used as a base.",
    existingInvoice:
      "Details preloaded from the existing invoice. Change whatever you need to correct.",
  },
  status: {
    sent: "Issued",
    processing: "Processing",
    pending: "Pending",
    error: "Error",
  },
  toast: {
    whatsappSent: "Invoice sent via WhatsApp.",
    whatsappError: "The invoice couldn't be sent via WhatsApp.",
    draftCreated: "Draft created. Review it and issue it when it's ready.",
  },
  validation: {
    nameRequired: "The name or legal name is required.",
    countryInvalid: "Select a valid country.",
    emailInvalid: "Enter a valid email.",
    taxIdRequired: "This tax ID is required for this recipient type.",
  },
  errors: {
    conflict: "The booking already has an invoice created.",
    checkData: "Check the billing details.",
    createFailed: "The invoice couldn't be created.",
  },
  taxId: {
    labels: {
      esCompany: "Company NIF",
      brIndividual: "CPF or RG",
      defaultIndividual: "Tax identification number",
      defaultCompany: "Tax number",
    },
    hints: {
      esIndividual: "DNI or NIE (X1234567A). A passport is not a valid tax ID.",
      esCompany: "Company NIF/CIF.",
      ptIndividual: "9 digits.",
      ptCompany: "9 digits.",
      coIndividual: "6-10 digits.",
      coCompany: "NIT with check digit.",
      mxIndividual: "RFC for a natural person.",
      mxCompany: "RFC for a legal entity.",
      arIndividual: "11 digits with check digit.",
      arCompany: "11 digits with check digit.",
      clIndividual: "With check digit.",
      clCompany: "With check digit.",
      peIndividual: "8 digits.",
      peCompany: "11 digits.",
      ecIndividual: "10 digits.",
      ecCompany: "13 digits.",
      brIndividual:
        "Valid CPF for tax invoicing. If you enter an RG, it will be saved as the guest's local ID.",
      brCompany: "14 digits.",
      defaultIndividual: "Optional.",
      defaultCompany: "Required for companies.",
    },
  },
  address: {
    ES: { city: "City", state: "Province", zip: "Postal code" },
    PT: { city: "City", state: "District", zip: "Postal code" },
    CO: { city: "City", state: "Dept.", zip: "Postal code" },
    MX: { city: "City", state: "State", zip: "Postal code" },
    AR: { city: "City", state: "Province", zip: "Postal code" },
    CL: { city: "City", state: "Region", zip: "Postal code" },
    BR: { city: "City", state: "State", zip: "CEP" },
    US: { city: "City", state: "State", zip: "ZIP" },
    GB: { city: "City", state: "County", zip: "Postcode" },
    DEFAULT: { city: "City", state: "Region", zip: "Postal code" },
  },
  taxErrors: {
    cifCompany: "Invalid company NIF/CIF.",
    esIndividual: "Invalid document. Enter a DNI, NIE (X1234567A) or passport.",
    ptNif: "Invalid NIF. It must have 9 valid digits.",
    nit: "Invalid NIT.",
    coCedula: "Invalid Cédula. Between 6 and 10 digits.",
    rfc: "Invalid RFC.",
    cuit: "Invalid CUIT.",
    cuilCuit: "Invalid CUIL/CUIT.",
    rut: "Invalid RUT.",
    ruc: "Invalid RUC.",
    peDni: "Invalid DNI. It must have 8 digits.",
    ecCedula: "Invalid Cédula.",
    cnpj: "Invalid CNPJ.",
    brIndividual: "Invalid document. Use a valid CPF or an RG in the usual format.",
  },
};
